import { enqueueSnackbar } from 'actions';
import {
	amGetTablesRequest, amGetTablesSuccess, amGetTablesFailure,
	amUpdateRevisedRequest, amUpdateRevisedSuccess, amUpdateRevisedFailure,
} from './availabilityActions';
import {
	AvailabilityManagementGetTablesRequest,
	AvailabilityManagementUpdateRevisedRequest,
} from '../requests/availabilityRequests';

// ─── GET TABLES — initial load ────────────────────────────────────────────────

export const amGetTables = () => async (dispatch) => {
	dispatch(amGetTablesRequest());
	await AvailabilityManagementGetTablesRequest().then((response) => {
		dispatch(amGetTablesSuccess(response.data ?? {}));
	}).catch((error) => {
		dispatch(amGetTablesFailure(error?.message));
	});
};

// ─── GET TABLES — silent poll ─────────────────────────────────────────────────

export const amPollTables = () => async (dispatch) => {
	await AvailabilityManagementGetTablesRequest().then((response) => {
		dispatch(amGetTablesSuccess(response.data ?? {}));
	}).catch(() => {});
};

// ─── UPDATE AVAILABILITY REVISED ──────────────────────────────────────────────
// dto → AvailabilityRevisedUpdateDto { id, table, dateWritten, date, polygon,
// type, valueRevised }
// `table` is 'Availability' or 'Blended' and tells the BE which column to write
// (AvailabilityRevised / BlendedRevised). An empty value clears it.

export const amUpdateRevised = (userId, dto, onSuccess) => async (dispatch) => {
	dispatch(amUpdateRevisedRequest());

	const payload = {
		...dto,
		valueRevised: dto.valueRevised === '' || dto.valueRevised == null
			? null
			: String(dto.valueRevised),
	};

	await AvailabilityManagementUpdateRevisedRequest(userId, payload).then(() => {
		dispatch(amUpdateRevisedSuccess());
		dispatch(amGetTables());
		if (onSuccess) onSuccess();
	}).catch((error) => {
		dispatch(amUpdateRevisedFailure(error?.message));
		dispatch(enqueueSnackbar({
			message: error?.message ?? 'Failed to save the revised value.',
			options: { variant: 'error' },
		}));
	});
};
